// DOM
SR.dom = {
    $win: $(window),
    $document: $(document),
    $root: $('html'),
    $doc: $('html, body'),
    $body: $('body'),
    $wrapper: $('.wrapper'),
    $scrollWrap: $('.scroll-wrapper'),
    $contentWrap: $('.content-wrapper'),
    $historyWrapper: $('.history-wrapper'),
    $askBar: $('.ask-bar'),
    $askSuggestion: $('.ask-suggestion'),
    $mask: $('.sr-mask'),
    $title: $('.app-title'),
};